import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IUserConfigurationRequest } from "../../interfaces/i-user-configuration-request";

@Injectable({
  providedIn: "root",
})
export class UserConfigCommunicatorService {
  private userConfigRequestSubject = new Subject<IUserConfigurationRequest>();

  public userConfigRequest$ = this.userConfigRequestSubject.asObservable();

  private userConfigResponseSubject = new Subject<IUserConfigurationRequest>();

  public userConfigResponse$ = this.userConfigResponseSubject.asObservable();

  saveUserConfigurationRequest(request: IUserConfigurationRequest) {
    this.userConfigRequestSubject.next(request);
  }

  setUserConfigResponse(response) {
    this.userConfigResponseSubject.next(response);
  }
}
